import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "../../assets/logo/nLogoTrans.png";
import { useNavigate } from "react-router-dom";
import "../CSS/Header.css";

const dropdownVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

const nestedDropdownVariants = {
  hidden: { opacity: 0, x: 10 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.3 } },
};

const mobileSubmenuVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
};

const Header = () => {
  // State for mobile side menu
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // State for desktop dropdown: track which top-level menu is open (if any)
  const [openDropdown, setOpenDropdown] = useState(null);
  // For nested dropdown inside a submenu on desktop
  const [openNestedDropdown, setOpenNestedDropdown] = useState({ parentIndex: null, childIndex: null });
  // For mobile submenus (top-level only)
  const [expandedMenus, setExpandedMenus] = useState([]);
  // State for showing the consultation popup
  const [showConsultationPopup, setShowConsultationPopup] = useState(false);
  // State for language dropdown and active language
  const [isLangDropdownOpen, setIsLangDropdownOpen] = useState(false);
  const [language, setLanguage] = useState("English");

  // Ref for language dropdown container (desktop & mobile)
  const langDropdownRef = useRef(null);

  // Close language dropdown if click occurs outside its container
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        langDropdownRef.current &&
        !langDropdownRef.current.contains(event.target)
      ) {
        setIsLangDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItems = [
    { label: "Home", path: "/" },
    {
      label: "Services",
      path: "/services",
      // submenu: [
      //   {
      //     label: "ASIC Design",
      //     path: "/services/asic-design",
      //     submenu: [
      //       { label: "Front-End RTL Design", path: "/services/asic-design/front-end-RTL-design" },
      //       { label: "IP Development", path: "/services/asic-design/ip-development" },
      //       { label: "SoC Integrations", path: "/services/asic-design/soc-integration" },
      //       { label: "Low-Power Design", path: "/services/asic-design/low-power-design" },
      //     ],
      //   },
      //   {
      //     label: "ASIC Verification",
      //     path: "/services/asic-verification",
      //     submenu: [
      //       { label: "UVM-based Testbenches", path: "/services/asic-verification/uvm-based-testbenches" },
      //       { label: "Functional Verification", path: "/services/asic-verification/functional-verification" },
      //       { label: "Formal Verification", path: "/services/asic-verification/formal-verification" },
      //       { label: "Regression Testing and Coverage", path: "/services/asic-verification/regression-testing-and-coverage" },
      //     ],
      //   },
      // ],
    },
    {
      label: "Technologies",
      path: "/technologies",
      // submenu: [
      //   { 
      //     label: "Tools and Languages",
      //     path: "/technologies/tools-and-languages",
      //     submenu: [
      //       { label: "SystemVerilog", path: "/technologies/tools-and-language/systemverilog" },
      //       { label: "VHDL", path: "/technologies/tools-and-language/vhdl" },
      //       { label: "UVM", path: "/technologies/tools-and-language/uvm" },
      //       { label: "Formal Verification Tools", path: "/technologies/tools-and-language/formal-verification-tools" },
      //     ],
      //   },
      //   {
      //      label: "Methodologies",
      //      path: "/technologies/methodologies",
      //      submenu: [
      //       { label: "Agile Hardware Development", path: "/technologies/methodologies/agile-hardware-development" },
      //       { label: "Continuous Integration and Delivery", path: "/technologies/methodologies/ci-cd" }
      //     ],
      //   },
      //   { label: "Platforms", path: "/technologies/platforms", submenu: [{ label: "Emulators", path: "/technologies/platforms/emulators" }]},
      // ],
    },
    {
      label: "Careers",
      submenu: [
        { label: "Job Openings", path: "/careers/job-openings" },
        { label: "Application", path: "/careers/application-submission-form" },
      ],
    },
    {
      label: "About Us",
      path: "/about-us",
    },
  ];

  const navigate = useNavigate();
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  // Desktop dropdown handling
  const handleMouseEnter = (index) => {
    setOpenDropdown(index);
  };
  const handleMouseLeave = () => {
    setOpenDropdown(null);
    setOpenNestedDropdown({ parentIndex: null, childIndex: null });
  };

  // Nested submenu handling for desktop
  const handleNestedMouseEnter = (parentIndex, childIndex) => {
    setOpenNestedDropdown({ parentIndex, childIndex });
  };
  const handleNestedMouseLeave = () => {
    setOpenNestedDropdown({ parentIndex: null, childIndex: null });
  };

  // Mobile submenu handling for top-level
  const toggleSubmenu = (label) => {
    if (expandedMenus.includes(label)) {
      setExpandedMenus(expandedMenus.filter((item) => item !== label));
    } else {
      setExpandedMenus([...expandedMenus, label]);
    }
  };

  // Consultation popup handling
  const openConsultationPopup = () => {
    // setShowConsultationPopup(true); 
    navigate("/contact");
  };
  const goToHomePage = () => {
    navigate("/")
  };
  const closeConsultationPopup = () => {
    setShowConsultationPopup(false);
  };

  // Toggle language dropdown
  const toggleLangDropdown = () => {
    setIsLangDropdownOpen(!isLangDropdownOpen);
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    setIsLangDropdownOpen(false);
  };

  return (
    <>
      <header className="main-header">
        {/* Logo */}
        <div className="logo">
          <img src={Logo} alt="Logo" onClick={goToHomePage}/>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav desktop-nav">
          <ul>
            {menuItems.map((menu, index) => (
              <li
                key={menu.label}
                className="nav-item"
                onMouseEnter={() => handleMouseEnter(index)}
                onMouseLeave={handleMouseLeave}
              >
                {menu.submenu ? (
                  <>
                    <Link to={menu.path} className="nav-link">
                      {menu.label}
                      <span className={openDropdown === index ? "arrow rotate" : "arrow"}>
                        ▾
                      </span>
                    </Link>
                    {openDropdown === index && (
                      <motion.ul
                        className="dropdown"
                        variants={dropdownVariants}
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                      >
                        {menu.submenu.map((sub, childIndex) => (
                          <li
                            key={sub.label}
                            className={sub.submenu ? "has-nested" : ""}
                            onMouseEnter={
                              sub.submenu ? () => handleNestedMouseEnter(index, childIndex) : undefined
                            }
                            onMouseLeave={sub.submenu ? handleNestedMouseLeave : undefined}
                          >
                            <Link to={sub.path}>{sub.label}</Link>
                            {sub.submenu &&
                              openNestedDropdown.parentIndex === index &&
                              openNestedDropdown.childIndex === childIndex && (
                                <motion.ul
                                  className="nested-dropdown"
                                  variants={nestedDropdownVariants}
                                  initial="hidden"
                                  animate="visible"
                                  exit="hidden"
                                >
                                  {sub.submenu.map((nestedItem) => (
                                    <li key={nestedItem.label}>
                                      <Link to={nestedItem.path}>{nestedItem.label}</Link>
                                    </li>
                                  ))}
                                </motion.ul>
                              )}
                          </li>
                        ))}
                      </motion.ul>
                    )}
                  </>
                ) : (
                  <Link to={menu.path} className="nav-link">
                    {menu.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </nav>

        {/* Desktop Language Dropdown & Consultation Button */}
        <div className="lang-consult">
          <div className="lang-dropdown-container" ref={langDropdownRef}>
            {/* <button className="lang-btn" onClick={toggleLangDropdown}>
              Language <span className="arrow">{isLangDropdownOpen ? "▴" : "▾"}</span>
            </button> */}
            {isLangDropdownOpen && (
              <motion.ul
                className="lang-dropdown"
                variants={dropdownVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
              >
                <li onClick={() => changeLanguage("English")}>
                  <Link to="#">
                    English {language === "English" && <i className="fas fa-check checkmark"></i>}
                  </Link>
                </li>
                <li onClick={() => changeLanguage("Serbian")}>
                  <Link to="#">
                    Serbian {language === "Serbian" && <i className="fas fa-check checkmark"></i>}
                  </Link>
                </li>
              </motion.ul>
            )}
          </div>
          <button className="consultation-btn" onClick={openConsultationPopup}>
            Contact Us
          </button>
        </div>

        {/* Hamburger: Only visible on mobile */}
        <button className="hamburger" onClick={toggleMobileMenu}>
          <i className="fas fa-bars"></i>
        </button>

        {/* Mobile Side Menu */}
        <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menu-header">
            <div className="mobile-logo">
              <img src={Logo} alt="Company Logo" />
            </div>
            <button className="close-btn" onClick={toggleMobileMenu}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div className="mobile-menu-body">
            {/* Mobile Language Dropdown (only in mobile menu) */}
            {/* <div className="mobile-lang-dropdown" ref={langDropdownRef}>
              <button className="lang-btn" onClick={toggleLangDropdown}>
                Language <span className="arrow">{isLangDropdownOpen ? "▴" : "▾"}</span>
              </button>
              {isLangDropdownOpen && (
                <motion.ul
                  className="lang-dropdown"
                  variants={dropdownVariants}
                  initial="hidden"
                  animate="visible"
                  exit="hidden"
                >
                  <li onClick={() => changeLanguage("English")}>
                    <Link to="#">
                      English {language === "English" && <i className="fas fa-check checkmark"></i>}
                    </Link>
                  </li>
                  <li onClick={() => changeLanguage("Serbian")}>
                    <Link to="#">
                      Serbian {language === "Serbian" && <i className="fas fa-check checkmark"></i>}
                    </Link>
                  </li>
                </motion.ul>
              )}
            </div> */}
            <ul>
              {menuItems.map((menu) => (
                <li key={menu.label}>
                  {menu.submenu ? (
                    <>
                      <div className="mobile-menu-item" onClick={() => toggleSubmenu(menu.label)}>
                        {menu.label}
                        <span className="mobile-arrow">
                          {expandedMenus.includes(menu.label) ? "–" : "+"}
                        </span>
                      </div>
                      {expandedMenus.includes(menu.label) && (
                        <motion.ul
                          className="mobile-submenu"
                          variants={mobileSubmenuVariants}
                          initial="hidden"
                          animate="visible"
                          exit="hidden"
                        >
                          {menu.submenu.map((sub) => (
                            <li key={sub.label}>
                              {sub.submenu ? (
                                <>
                                  {/* For mobile, always show nested options */}
                                  <Link to={sub.path} onClick={toggleMobileMenu}>
                                    {sub.label}
                                  </Link>
                                  <motion.ul
                                    className="mobile-nested-submenu"
                                    variants={mobileSubmenuVariants}
                                    initial="hidden"
                                    animate="visible"
                                    exit="hidden"
                                  >
                                    {sub.submenu.map((nested) => (
                                      <li key={nested.label}>
                                        <Link to={nested.path} onClick={toggleMobileMenu}>
                                          {nested.label}
                                        </Link>
                                      </li>
                                    ))}
                                  </motion.ul>
                                </>
                              ) : (
                                <Link to={sub.path} onClick={toggleMobileMenu}>
                                  {sub.label}
                                </Link>
                              )}
                            </li>
                          ))}
                        </motion.ul>
                      )}
                    </>
                  ) : (
                    <Link to={menu.path} onClick={toggleMobileMenu}>
                      {menu.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
            {/* Mobile Request Consultation Button */}
            <button
              className="consultation-btn mobile-consultation-btn"
              onClick={() => {
                toggleMobileMenu();
                openConsultationPopup();
              }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </header>

      {/* Consultation Popup Modal */}
      {showConsultationPopup && (
        <div className="modal-overlay" onClick={closeConsultationPopup}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>Request Consultation</h3>
            <p>
              This is a placeholder for the consultation form. Please contact us for more details.
            </p>
            <button className="close-modal" onClick={closeConsultationPopup}>
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;